import { createClient } from "@sanity/client";

// Sanity configuration
const config = {
  projectId: "n1d6y33j",
  dataset: "production",
  apiVersion: "2023-09-01", // Use the latest API version
  useCdn: false,
};

export const client = createClient(config);

export default client;
